<template>
    <v-footer app absolute v-if="storeAuth.isAuth" class="d-flex text-caption justify-center bg-transparent pb-4">
        Luzern Solutions ©{{ new Date().getFullYear() }}
    </v-footer>
</template>
<script setup lang="ts">
import { useAuthStore } from '@/stores/useAuthStore'
const storeAuth = useAuthStore()
</script>
